import * as React from 'react';
import { useIntl } from 'react-intl';

import {
  DrawerContext,
  IconRegularWoman,
  ButtonModel,
} from '@notino/react-styleguide';

import { MultistepModal } from '@components/MultistepModal';
import { withProviders } from '@context/contextConfig';

import { useNewPdDesignEnabled } from '../../hooks/useNewPdDesignEnabled';

import { useScreenResizeChangeContainer } from './hooks/useScreenResizeChangeContainer';
import { useShadefinder } from './hooks/useShadefinder';
import { messages } from './messages';
import { ButtonShadefinderWrapper } from './styled';

interface IShadefinderProps {
  masterId: string;
}

const ShadefinderComponent: React.FC<IShadefinderProps> = ({ masterId }) => {
  const { formatMessage } = useIntl();
  const openShadefinder = useShadefinder(masterId);
  const newDesign = useNewPdDesignEnabled();

  useScreenResizeChangeContainer();

  return (
    <ButtonShadefinderWrapper
      buttonStyle={ButtonModel.Styles.secondary}
      fullWidth={newDesign}
      onClick={openShadefinder}
    >
      <IconRegularWoman />

      {formatMessage(messages.chooseYourVariant)}
    </ButtonShadefinderWrapper>
  );
};

export default withProviders<IShadefinderProps>(
  DrawerContext.Provider,
  MultistepModal.Provider
)(ShadefinderComponent);
